import React from 'react'

const SonyVP8000 = () => {
  return (
    <div>SonyVP8000</div>
  )
}

export default SonyVP8000